import { makeAutoObservable } from "mobx";
import {
  EmptyGroupResponseImpl,
  ObservableGroupPropImpl,
} from "../DTO/ServerResponseType/Group/Group";
import GroupServerClient from "../ServerClients/GroupServerClient";
import { GroupRequestImpl } from "../DTO/ClientRequest/GroupRequest";
import { ChangeEvent } from "react";
import { AppStoreApi } from "./AppStore";

export class GroupStore {
  group: ObservableGroupPropImpl;
  learningPathId: string;
  root: AppStoreApi;

  constructor(root: AppStoreApi) {
    this.group = new ObservableGroupPropImpl(new EmptyGroupResponseImpl());
    this.learningPathId = "";
    this.root = root;
    makeAutoObservable(this);
  }

  get saveWindowTitle(): string {
    return "Создание группы";
  }

  get saveButtonText(): string {
    return "Создать группу";
  }

  saveClickAsync() {
    let request = new GroupRequestImpl({
      groupName: this.group.groupName,
      learningPathId: this.learningPathId,
    });

    return GroupServerClient.sendToCreateGroupAsync(request).then(() => {
      this.root.groupsStore.loadAllGroupsAsync();
    });
  }

  onChangeLearningPathId = (event: ChangeEvent<HTMLSelectElement>): void => {
    this.learningPathId = event.currentTarget.value;
  };

  onChangeName = (event: ChangeEvent<HTMLInputElement>) => {
    this.group.onChangeName(event.currentTarget.value);
  };

  clear = () => {
    this.group = new ObservableGroupPropImpl(new EmptyGroupResponseImpl());
    this.learningPathId = "";
  };
}
